// extracted by mini-css-extract-plugin
export default {"agencyResultsHolder":"style-module--agencyResultsHolder--54465","cards":"style-module--cards--4ac6e","card":"style-module--card--f27e1","sorting":"style-module--sorting--5b04b"};